import { createContext } from "react";

/**
 * OrderContext provides state management for order data synchronization
 * across components in the order entry flow.
 *
 * Used when child components make direct API changes (e.g., delivery window updates)
 * that need to be reflected in parent component state.
 */
export interface IOrderContextModel {
    /**
     * Flag indicating the order data is stale and needs to be refreshed
     */
    needsRefresh: boolean;

    /**
     * Mark the order as needing a refresh (e.g., after a direct API save)
     */
    markNeedsRefresh: () => void;

    /**
     * Refresh the order data from the server
     */
    refreshOrder: () => void;
}

export const OrderContext = createContext<IOrderContextModel | null>(null);

/**
 * Default/empty implementation for when context is not available
 */
export const defaultOrderContext: IOrderContextModel = {
    needsRefresh: false,
    markNeedsRefresh: () => {},
    refreshOrder: () => {},
};

export default OrderContext;
